import _ from "lodash"
import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"

import {
  getUsername,
  getSession,
  getCurrentUser,
  getSessionExpire,
} from "../../../helpers/AuthType/authService"
import SessionTimeout from "components/Common/SessionTimeout"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

const ProfileMenu = props => {
  // Declare a new state variable, which we'll call "menu"
  const [menu, setMenu] = useState(false)

  const [username, setusername] = useState(false)

  const [session, setSession] = useState(getSession())

  useEffect(() => {
    if (session && _.has(session,'coapplication') && session.coapplication) {
      setusername(getCurrentUser()._applicant)
    }
  }, [props.success])

  return (
    <React.Fragment>
      <SessionTimeout />
      {username && (<Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item "
          id="page-header-user-dropdown"
          tag="button"
        >
          <i className="fas fa-user"></i>
          <span className="d-none d-xl-inline-block ms-2 me-1">{username}</span>
          <i className="mdi mdi-chevron-down d-none d-xl-inline-block" />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          <Link to="#" className="dropdown-item">
          <i className="bx bx-user font-size-16 align-middle me-1 text-secondary" />
          <span>{props.t(username)}</span>
          </Link>
          <div className="dropdown-divider" />

          {/* <Link to="/logout" className="dropdown-item">
            <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link> */}
        </DropdownMenu>
      </Dropdown>)}
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
}

const mapStatetoProps = state => {
  
  const { error, success } = _.isUndefined(state.Profile) ? {error : false, success : true} : state.Profile
  return { error, success }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu))
)
